import { Column, Editing, Item, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';

export const IlTanimlari = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const ref = useRef();
    const mountedRef = useRef(true);

    useEffect(() => {
        fetchData();
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.post("/city/getAll");
            if (mountedRef.current) {
                let all_data = response.data.data || []
                setDataSources(
                    all_data.filter((item) => (item.id !== 7))
                );
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching cities:", error);
        }
    };

    const addModel = async (data, e) => {
        try {
            data.create_user_id = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
            data.city_code = "";

            const response = await api.post("/city/create", data);
            if (response.status === 200) {
                toast.success(t("Ekleme başarılı"));
                fetchData();
                return true;
            }
            return false;
        } catch (error) {
            console.error("Error adding city:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
            return false;
        }
    };

    const updateModel = async (e, data) => {
        try {
            const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
            const body = {
                ...data.oldData,
                ...data.newData,
                update_user_id: employeeId,
                update_date: new Date().toISOString()
            };

            const response = await api.post("/city/update", body);
            if (response.status === 200) {
                toast.success(t("Güncelleme başarılı"));
                fetchData();
                return true;
            }
            return false;
        } catch (error) {
            console.error("Error updating city:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
            return false;
        }
    };

    const onRowValidating = async (e) => {
        if (e.brokenRules.length === 0) {
            e.isValid = false;
            e.cancel = true;

            let success;
            if (!e.oldData) {
                success = await addModel(e.newData, e);
            } else {
                success = await updateModel(e, e);
            }

            if (success) {
                e.component.cancelEditData();
            }
        }
    };

    return (
        <>
            <Breadcrumb current={t("İl Tanımları")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="popup"
                        popup={{
                            title: t("Yeni İl Tanımı"),
                            showTitle: true,
                            width: 700,
                            height: "auto",
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column dataField="city_code" caption={t("Şehir Kodu")} selectedFilterOperation='contains' alignment='center'
                        allowEditing={false}
                        cellRender={(data) => {
                            if (data.text === "") {
                                return <i>OTOMATİK</i>
                            } else return <>{data.data.city_code}</>
                        }}
                    />
                    <Column dataField="city_name" caption={t("Şehir Adı")} selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>
                    <Column dataField="grupaj_time" caption={t("Grupaj Süresi")} dataType="number" alignment='center' visible={false}>
                        <RequiredRule />
                    </Column>
                    <Column dataField="shipping_time" caption={t("Sevkiyat Süresi")} dataType="number" alignment='center' visible={false}>
                        <RequiredRule />
                    </Column>
                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                onClick={fetchData}
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd"
                                }}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                            &nbsp;
                            <RxButton
                                className='btn btn-success'
                                style={{
                                    color: "white",
                                    paddingInline: "10px",
                                }}
                                onClick={(e) => ButtonOnExporting(e, ref, "İl Tanımları")}>
                                <i className="fa fa-file-excel-o"></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};


